import React from 'react';
import MultiViewTable from './MultiViewTable';

const MultiViewManagement = () => {
    return <MultiViewTable />;
};

export default MultiViewManagement;
